import cn from 'classnames'
import React, { ChangeEvent, ComponentProps, ReactElement } from 'react'

import style from './LabelToggle.style'

export type LabelToggleOption = {
  displayName: string
  value: string
}

type LabelToggleProps = {
  className?: string
  options: LabelToggleOption[]
  name: string
  onChange: (selectedValue: LabelToggleOption) => void
  value: string
} & Omit<ComponentProps<'div'>, 'onChange'>

function LabelToggle(props: LabelToggleProps): ReactElement {
  const { className = '', options, onChange, value, name, ...rest } = props

  const handleSelect = (e: ChangeEvent<HTMLInputElement>): void => {
    const selectedOption = options.find(
      (option) => option.value === e.target.dataset.value,
    )
    if (selectedOption) {
      onChange?.(selectedOption)
    }
  }

  return (
    <div className={cn('LabelToggle', className)} css={style} {...rest}>
      <div className="LabelToggle-container">
        {options.map((option) => {
          const { value: optionValue, displayName } = option
          return (
            <div key={optionValue} className="LabelToggle-option">
              <input
                className="LabelToggle-option-radio"
                type="radio"
                id={`${name}_${optionValue}`}
                name={name}
                onChange={handleSelect}
                checked={value === optionValue}
                data-value={optionValue}
              />
              <label
                className={cn('LabelToggle-option-label', {
                  selected: optionValue === value,
                })}
                htmlFor={`${name}_${optionValue}`}
              >
                {displayName}
              </label>
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default LabelToggle
